import { useState } from "react";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import Modal from "../../elements/Modal";
import buttoncss from "../../../myfin_v2/css/button.module.css";
import InputGroup from "../../elements/InputGroup";
import { Button } from "../../elements/Button";
import commoncss from "../../../myfin_v2/css/common.module.css"


import { ReactComponent as CloseIcon } from "../../../myfin_v2/assets/icons/close.svg";
import CustomDropdownIndicator from "../../elements/CustomDropdownIndicator";
import { createIssuedCapital,  updateIssuedCapital } from "../../../WorkSpace/Components/ApiServices/apiHandler";

export const customStyles = {
    control: (provided, state) => ({
        ...provided,
        backgroundColor: '#f4faf5',
        borderColor: '#c2e6d1',
        color: '#b3c0bd',
        boxShadow: state.isFocused ? '0 0 0 1px #c2e6d1' : 'none',
        borderWidth: '1px',
        borderRadius: '10px',
        '&:hover': {
            borderColor: '#b3c0bd',
        },
        minHeight: '38px',
        height: '38px',
    }),
    valueContainer: (provided) => ({
        ...provided,
        padding: '2px 8px',
        paddingTop: '1px',
    }),
    input: (provided) => ({
        ...provided,
        color: '#b3c0bd',
    }),
    placeholder: (provided) => ({
        ...provided,
        color: '#b3c0bd',
        fontSize: '14px',
    }),
    singleValue: (provided) => ({
        ...provided,
        color: '#4d6d64',
        fontSize: '14px',
    }),
    multiValue: (provided) => ({
        ...provided,
        backgroundColor: '#e0f5e9',
        borderRadius: '0.25rem',
        border: '1px solid #c2e6d1',
        width: 'fit-content',
    }),
    multiValueLabel: (provided) => ({
        ...provided,
        color: '#4d6d64',
    }),
    multiValueRemove: (provided) => ({
        ...provided,
        color: '#b3c0bd',
        ':hover': {
            backgroundColor: '#c2e6d1',
            color: '#4f665f',
        },
    }),
    indicatorsContainer: (provided) => ({
        ...provided,
        color: '#b3c0bd',
    }),
    dropdownIndicator: (provided) => ({
        ...provided,
        color: '#1A4338',
        fontWeight: 400,
        ':hover': {
            color: '#1A4338',
            fontWeight: 400,
        },
    }),
    clearIndicator: (provided) => ({
        ...provided,
        color: '#b3c0bd',
        ':hover': {
            color: '#4f665f',
        },
    }),
    menu: (provided) => ({
        ...provided,
        backgroundColor: '#ffffff',
        border: '1px solid #c2e6d1',
        borderRadius: '6px',
        boxShadow: '0 0 0 1px #c2e6d1',
        marginTop: '6px',
        zIndex: 10,
    }),
    menuList: (provided) => ({
        ...provided,
        padding: '4px',
        borderRadius: '6px',
    }),
    option: (provided, state) => ({
        ...provided,
        backgroundColor: state.isSelected
            ? '#c2e6d1'
            : state.isFocused
                ? '#f4faf5'
                : 'transparent',
        color: '#4f665f',
        padding: '10px 12px',
        cursor: 'pointer',
        fontSize: '14px',
        borderRadius: '8px',
        // margin: '4px 6px',
    }),
    noOptionsMessage: (provided) => ({
        ...provided,
        color: '#b3c0bd',
        padding: '8px 12px',
    }),
};


const IssuedCapitalModal = ({ handleClose, data, type, classOfShareOptions, relationshipOptions, investmentID, refreshData, linkedCompanies, companyId }) => {

    const animatedComponents = makeAnimated();
    const [shareHolderType, setShareHolderType] = useState(
    type === "edit" ? data?.shareHolderType || "Individual" : "Individual"
    );

    const [shareHolderCompanyID, setShareHolderCompanyID] = useState(
    type === "edit" ? data?.shareHolderCompanyID : null
    );

    const [shareHolderName, setShareHolderName] = useState(
    type === "edit" ? data?.shareHolderName : ""
    );

    const [selectedClassOfShare, setSelectedClassOfShare] = useState(
        type === "edit" && data?.classOfShare
        ? { label: data.classOfShare, value: data.classOfShare }
        : null
    );
    
    const [selectedRelationship, setSelectedRelationship] = useState(
        type === "edit" && data?.relationship
        ? { label: data.relationship, value: data.relationship }
        : null
    );

    const [noOfShares, setNoOfShares] = useState(
        type === "edit" ? data?.noOfShares : ""
    );

    const [faceValue, setFaceValue] = useState(
        type === "edit" ? data?.faceValue : ""
    );

    const [amount, setAmount] = useState(
        type === "edit" ? data?.amount : ""
    );

    const [holdingPercentage, setHoldingPercentage] = useState(
        type === "edit" ? data?.holdingPercentage : ""
    );

     const [loading, setLoading] = useState(false);

    const handleSubmit = async () => {
  try {
    setLoading(true);

    const payload = {
      companyID: companyId,

      shareHolderType,
      shareHolderCompanyID:
        shareHolderType === "Company" ? shareHolderCompanyID : null,
      shareHolderName:
        shareHolderType === "Individual" ? shareHolderName : "",

      relationship: selectedRelationship?.value,
      classOfShare: selectedClassOfShare?.value,

      noOfShares: Number(noOfShares),
      faceValue: Number(faceValue),
      amount: Number(amount),

      holdingPercentage: Number(holdingPercentage),
    };

    console.log("Issued Capital Payload:", payload);

    let res;

    if (type === "edit") {

      res = await updateIssuedCapital(
        investmentID,
        data._id,  
        payload
      );
      
    } else {
      res = await createIssuedCapital(investmentID, payload);
    }

    if (res?.data?.success) {
      alert(
        type === "edit"
          ? "Issued Capital Updated "
          : "Issued Capital Created"
      );
      refreshData();
      handleClose();
    }

  } catch (error) {
    console.error("Error saving Issued Capital:", error);
    alert("Something went wrong ❌");
  } finally {
    setLoading(false);
  }
};

    return(
        <>
            <style>
                {`
                    input.no-spinner::-webkit-outer-spin-button,
                    input.no-spinner::-webkit-inner-spin-button {
                        -webkit-appearance: none;
                        margin: 0;
                    }

                    input.no-spinner[type=number] {
                        -moz-appearance: textfield; /* Firefox */
                    }
                `}
            </style>
            <Modal
                width="700px"
                title={type === "edit" ? "Edit Issued Capital" : "Create Issued Capital"}
                bodycss={commoncss.unsetPadding}
                headerActions={
                    <CloseIcon
                        className="clickable"
                        onClick={handleClose}
                    />
                }
                footerActions={
                    <>
                        <Button
                            btnColor={buttoncss.secondary}
                            label="Cancel"
                            onClick={handleClose}
                        />
                        <Button
                            btnColor={buttoncss.primary}
                            label={type === "edit" ? "Update" : "Create Issued Capital"}
                            onClick={handleSubmit}
                        />
                    </>
                }
            >

                <div className={commoncss.pd1530}>
                    <div style={{ gap: "30px" }} className="d-flex align-items-center mb-2">
                    <label className="me-3 d-flex align-items-center">
                        <input
                        type="radio"
                        value="Company"
                        checked={shareHolderType === "Company"}
                        onChange={() => setShareHolderType("Company")}
                        />
                        <span className="ms-1">Company</span>
                    </label>

                    <label className="d-flex align-items-center">
                        <input
                        type="radio"
                        value="Individual"
                        checked={shareHolderType === "Individual"}
                        onChange={() => {
                            setShareHolderType("Individual");
                            setShareHolderCompanyID(null);
                        }}
                        />
                        <span className="ms-1">Individual</span>
                    </label>
                    </div>
                    <InputGroup
                    label="Shareholder"
                    inputs={[
                        <>
                        {shareHolderType === "Individual" ? (
                            <input
                            type="text"
                            placeholder="Enter Name"
                            value={shareHolderName}
                            onChange={(e) => setShareHolderName(e.target.value)}
                            />
                        ) : (
                            <Select
                            placeholder="Select shareholder"
                            options={(linkedCompanies || []).map(c => ({
                                label: c.companyName,
                                value: c._id,
                            }))}
                            styles={customStyles}
                            components={{
                                IndicatorSeparator: () => null,
                                DropdownIndicator: CustomDropdownIndicator,
                            }}
                            value={
                                shareHolderCompanyID
                                ? linkedCompanies
                                    .map(c => ({ label: c.companyName, value: c._id }))
                                    .find(opt => opt.value === shareHolderCompanyID)
                                : null
                            }
                            onChange={(opt) => setShareHolderCompanyID(opt?.value || null)}
                            />
                        )}
                        </>,
                    ]}
                    />
                    <span className="input-label">Relationship</span>
                    <Select
                        placeholder="Relationship"
                        options={relationshipOptions.map((option) => ({
                            label: option,
                            value: option,
                        }))}
                        className={`basic-multi-select w-100 mt-1 mb-2`}
                        classNamePrefix="select"
                        components={{
                            ...animatedComponents,
                            IndicatorSeparator: () => null,
                            DropdownIndicator: CustomDropdownIndicator,
                        }}
                        styles={customStyles}
                        value={selectedRelationship}
                        onChange={(opt) => setSelectedRelationship(opt)}

                    />
                    <InputGroup
                        inputs={[
                        <>
                            <span className="input-label">Class of share</span>
                            <Select
                                placeholder="Enter class of share"
                                options={classOfShareOptions.map((option) => ({
                                    label: option,
                                    value: option,
                                }))}
                                className={`basic-multi-select w-100 mt-1 mb-2`}
                                classNamePrefix="select"
                                components={{
                                    ...animatedComponents,
                                    IndicatorSeparator: () => null,
                                    DropdownIndicator: CustomDropdownIndicator,
                                }}
                                styles={customStyles}
                                value={selectedClassOfShare}
                                onChange={(opt) => setSelectedClassOfShare(opt)}

                            />
                        </>,
                        <>
                            <InputGroup
                                label="No of shares"
                                inputs={[
                                <>
                                    <input
                                        type="number"
                                        placeholder="Enter number of shares"
                                        onWheel={(e) => e.target.blur()}
                                        className="no-spinner"
                                        value={noOfShares}
                                        onChange={(e) => setNoOfShares(e.target.value)}
                                        // defaultValue={type === "edit" ? data?.numberOfShares : ""}
                                    />
                                </>,
                                ]}
                            />
                        </>,
                        ]}
                    />
                    {/* <InputGroup
                        label="No of shares"
                        inputs={[
                        <>
                            <input
                                type="number"
                                onWheel={(e) => e.target.blur()}
                                className="no-spinner"
                                defaultValue={type === "edit" ? data?.numberOfShares : ""}
                            />
                        </>,
                        ]}
                    /> */}
                    <InputGroup
                        inputs={[
                        <>
                            <InputGroup
                                label="Face value"
                                inputs={[
                                <>
                                    <input
                                        type="number"
                                        placeholder="Enter value"
                                        onWheel={(e) => e.target.blur()}
                                        className="no-spinner"
                                        value={faceValue}
                                        onChange={(e) => setFaceValue(e.target.value)}
                                        // defaultValue={type === "edit" ? data?.faceValue : ""}
                                    />
                                </>,
                                ]}
                            />
                        </>,
                        <>
                            <InputGroup
                                label="Amount"
                                inputs={[
                                    <>
                                        <input
                                            type="number"
                                                placeholder="Enter amount"
                                                onWheel={(e) => e.target.blur()}
                                                className="no-spinner"
                                                value={amount}
                                                onChange={(e) => setAmount(e.target.value)}
                                               // defaultValue={type === "edit" ? data?.amount : ""}
                                        />
                                    </>,
                                ]}
                            />  
                        </>
                        ]}
                    />
                    <InputGroup
                        label="Holding% (Fully Diluted/Equity Share)"
                        inputs={[
                            <>
                                <input
                                    type="text"
                                    placeholder="Enter hoding percentage"
                                    value={holdingPercentage}
                                    onChange={(e) => setHoldingPercentage(e.target.value)}
                                  //  defaultValue={type === "edit" ? data?.holding : ""}
                                />
                            </>,
                        ]}
                    />
                </div>
            </Modal>
        </>
    )

}

export default IssuedCapitalModal;